export const statusValue =[
    `Available`,
    `Busy`,
]